var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-info robot3s" }, [
    _c("div", { attrs: { id: "info-b1" } }, [
      _c("div", { staticClass: "bg-mask", class: { zoomIn: _vm.isB1Visible } }),
      _c("div", { staticClass: "ww" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "p1 delay3", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("维拉3S    科技与康养完美结合")]
          ),
          _c(
            "div",
            { staticClass: "p2 delay4", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("首款面向健康养老的智慧康养服务机器人")]
          ),
          _c(
            "div",
            { staticClass: "p3 delay5", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("安全看护  ｜  健康管理  ｜  精神陪护")]
          )
        ]),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            { staticClass: "p4 delay5", class: { fadeUp: _vm.isB1Visible } },
            [
              _c("img", {
                staticClass: "img",
                attrs: { src: require("../../../assets/web/star.png") }
              }),
              _c("span", [_vm._v("上海市专精特新产品")])
            ]
          ),
          _c(
            "div",
            { staticClass: "p4 delay5", class: { fadeUp: _vm.isB1Visible } },
            [
              _c("img", {
                staticClass: "img",
                attrs: { src: require("../../../assets/web/star.png") }
              }),
              _c("span", [_vm._v("上海市重大高端智能装备")])
            ]
          ),
          _c(
            "div",
            { staticClass: "p4 delay5", class: { fadeUp: _vm.isB1Visible } },
            [
              _c("img", {
                staticClass: "img",
                attrs: { src: require("../../../assets/web/star.png") }
              }),
              _c("span", [_vm._v("上海市人工智能创新产品")])
            ]
          )
        ])
      ])
    ]),
    _c("div", { attrs: { id: "info-b2" } }, [
      _c("div", { staticClass: "ww" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("认识人 / 家")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("随叫随到  主动跟随服务 ")]
        ),
        _c(
          "div",
          { staticClass: "p0 delay3", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("如家人般  熟悉家中每一个角落")]
        ),
        _c(
          "div",
          { staticClass: "p3 deplay4", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("人脸识别  ｜  自主建图  ｜  自主导航")]
        ),
        _c("div", { staticClass: "p4" }, [
          _c(
            "div",
            {
              staticClass: "item delay5",
              class: { fadeDown: _vm.isB2Visible }
            },
            [
              _c("img", {
                attrs: { src: require("../../../assets/web/3s-info-1.png") }
              }),
              _c("br"),
              _c("span", [_vm._v("人脸识别")])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "item delay6",
              class: { fadeDown: _vm.isB2Visible }
            },
            [
              _c("img", {
                attrs: { src: require("../../../assets/web/3s-info-2.png") }
              }),
              _c("br"),
              _c("span", [_vm._v("人体识别")])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "item delay7",
              class: { fadeDown: _vm.isB2Visible }
            },
            [
              _c("img", {
                attrs: { src: require("../../../assets/web/3s-info-3.png") }
              }),
              _c("br"),
              _c("span", [_vm._v("步态识别")])
            ]
          )
        ])
      ])
    ]),
    _c("div", { attrs: { id: "info-b3" } }, [
      _c("div", { staticClass: "ww" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("安全居家")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("机器人自主移动寻人 前往事发现场")]
        ),
        _c(
          "div",
          { staticClass: "p0 delay3", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("视频通话联系家人紧急救援")]
        ),
        _c(
          "div",
          { staticClass: "p3 deplay4", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("跌倒求助  ｜  语音呼救  ｜  安全监测")]
        ),
        _c("div", { staticClass: "p4" }, [
          _c(
            "div",
            {
              staticClass: "item delay5",
              class: { fadeDown: _vm.isB3Visible }
            },
            [
              _c("img", {
                attrs: { src: require("../../../assets/web/3s-info-4.png") }
              })
            ]
          )
        ])
      ])
    ]),
    _c("div", { attrs: { id: "info-b4" } }, [
      _c("div", { staticClass: "ww" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("健康管理")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("机器人主动用药提醒  健康服务")]
        ),
        _c(
          "div",
          { staticClass: "p0 delay3", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("智能导诊多轮对话  家庭全科医生")]
        ),
        _c(
          "div",
          { staticClass: "p3 deplay4", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("用药提醒  ｜  智能导诊  ｜  健康百科 ")]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b5" } }, [
      _c("div", { staticClass: "ww" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB5Visible } },
          [_vm._v("精神陪伴")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB5Visible } },
          [_vm._v("远程视频与家人亲情互动")]
        ),
        _c(
          "div",
          { staticClass: "p0 delay3", class: { fadeUp: _vm.isB5Visible } },
          [_vm._v(" 陪伴闲聊 播放影音娱乐节目")]
        ),
        _c(
          "div",
          { staticClass: "p3 deplay4", class: { fadeUp: _vm.isB5Visible } },
          [_vm._v("亲情关怀  ｜  日常闲聊  ｜  休闲娱乐 ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-021a1df4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021a1df4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/3s/info.vue
// module id = IuYu
// module chunks = 0